import React from "react";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Modal } from "react-bootstrap";
// import Modal from '@mui/material/Modal';

import "bootstrap/dist/css/bootstrap.min.css";
import "./CustomModal.css";

export default function CustomModal(props: any) {
  const { body, size, show, onChange, title } = props;
  return (
    <Modal
      size={size ?? "md"}
      show={show}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      <Modal.Header className=" modalHeader raleway-bold-white-15px">
        <Modal.Title>{title}</Modal.Title>
        <IconButton style={{ color: "white" }} onClick={() => onChange(!show)}>
          <CloseIcon></CloseIcon>
        </IconButton>
      </Modal.Header>
      
      { show ? <Modal.Body>{body}</Modal.Body> : <></>}

    </Modal>
  );
}
